const COLTYPES = new Set(['string', 'number', 'date', 'boolean']);
const JSON_SAFE_OPTION = /^(on[A-Z]|dataset$|columns$|renderCell$|customEditor$|validateRows$|layoutStore$|noteStore$)/;
/** 저장 규칙에서 편집 가능한 그리드 컬럼 (매핑됨 · 키·버전 아님) */
export function editableColumns(rules) {
    const s = new Set();
    for (const t of rules?.tables ?? [])
        for (const g of Object.keys(t.columns ?? {}))
            if (!(t.key ?? []).includes(g) && g !== t.version)
                s.add(g);
    return s;
}
/** 화면 정의 → 그리드 설정 (순수). 매핑 안 된 컬럼은 editor:false, 함수 옵션·이벤트는 정의에서 받지 않음 */
export function screenSetup(def, baseUrl = '/api/screens') {
    const base = `${baseUrl.replace(/\/$/, '')}/${encodeURIComponent(def.screenId)}`;
    const editableSet = editableColumns(def.saveRules);
    const editable = editableSet.size > 0;
    const raw = { ...(def.options ?? {}) };
    for (const k of Object.keys(raw))
        if (JSON_SAFE_OPTION.test(k) || typeof raw[k] === 'function')
            delete raw[k];
    const rowModel = raw.rowModel === 'server' ? 'server' : 'client';
    delete raw.rowModel;
    const t0 = def.saveRules?.tables?.[0];
    const keyCol = raw.keyCol ?? (t0?.key?.length === 1 ? t0.key[0] : t0?.key?.length ? [...t0.key] : undefined);
    const columns = (def.columns ?? []).filter(c => c && typeof c.id === 'string').map(c => {
        const o = { ...c };
        for (const k of Object.keys(o))
            if (typeof o[k] === 'function')
                delete o[k];
        if (!editable || !editableSet.has(c.id))
            o.editor = false;
        return o;
    });
    const dsColumns = columns.filter(c => !c.expr).map(c => ({ id: c.id, type: (typeof c.type === 'string' && COLTYPES.has(c.type) ? c.type : 'string') }));
    const options = { ...raw, ...(keyCol ? { keyCol } : {}) };
    // 저장 규칙이 없으면 읽기 전용 화면 (프리셋이 입력이어도)
    if (!editable)
        options.editable = false;
    else if (options.editable == null)
        options.editable = true;
    return {
        preset: def.preset ?? undefined, columns, dsColumns, options, rowModel, keyCol, editable,
        versionCol: def.saveRules?.tables?.find(t => t.version)?.version,
        urls: { def: base, data: base + '/data', server: base + '/data/server', save: base + '/save', export: base + '/export' },
    };
}
/** 화면 정의 불러오기 */
export async function fetchScreenDef(screenId, baseUrl = '/api/screens', init) {
    const res = await fetch(`${baseUrl.replace(/\/$/, '')}/${encodeURIComponent(screenId)}`, { ...init, headers: { Accept: 'application/json', ...(init?.headers ?? {}) } });
    if (!res.ok)
        throw new Error(`화면 정의 조회 실패 (${res.status})`);
    return (await res.json());
}
